export default __webpack_public_path__ + "static/media/gallery-wip-handle_13.0e50d755.jpg";